import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { matchPath } from "react-router-dom";
import queryString from "query-string";
import Loader from "react-loader";

import { testerAccountPaths, websiteContentPaths } from "configuration/app_paths";
import { Tester } from "generated/graphql";

type RedirectionsFilterProps = {
  currentTester: Tester;
  children: React.ReactNode;
};

const RedirectionsFilter = ({ currentTester, children }: RedirectionsFilterProps) => {
  const [showChildren, setShowChildren] = useState(false);
  const history = useHistory();
  const { location } = history;

  useEffect(() => {
    handleRedirection();
    setShowChildren(true);
  }, []);

  const handleRedirection = () => {
    const { search, pathname } = location;
    const pathnameWithQueryString = pathname + search;
    const { profileCompletenessStage, checkUpVerification } = currentTester;
    const isRootPath = pathname === testerAccountPaths.root;
    const isVerificationPath = pathname === testerAccountPaths.checkUpVerification;
    const isSurveyPath =
      matchPath(pathname, { path: websiteContentPaths.surveys }) ||
      matchPath(pathname, { path: websiteContentPaths.surveyCompleted });
    const isRegularTester = profileCompletenessStage === "finished";
    const registrationStages = [
      "registration_confirmation",
      "account_settings",
      "testing_settings",
      "hardware_and_software",
      "community_test",
    ];
    const missingConsents = currentTester.outdatedConsents.length;
    const isConsentPath = pathname === testerAccountPaths.consent;

    if (missingConsents) {
      if (!isConsentPath) {
        redirectTo(testerAccountPaths.consent, { url: pathnameWithQueryString });
      }
    } else if (isRegularTester && checkUpVerification) {
      if (!isVerificationPath) {
        redirectTo(testerAccountPaths.checkUpVerification, { url: pathnameWithQueryString });
      }
    } else if (isRegularTester && !isRootPath) {
      // noop
    } else if (isSurveyPath) {
      // noop
    } else if (registrationStages.includes(profileCompletenessStage)) {
      registrationStatusesRedirection();
    } else {
      redirectTo(testerAccountPaths.dashboard);
    }
  };

  const redirectTo = (path: string, query = {}) => {
    const params = queryString.stringify(query);

    history.push({ pathname: path, search: params });
  };

  const registrationStatusesRedirection = () => {
    switch (currentTester.profileCompletenessStage) {
      case "registration_confirmation":
        redirectTo(testerAccountPaths.unconfirmedAccount);
        break;
      case "account_settings":
        redirectTo(testerAccountPaths.registrationAccountSettings);
        break;

      case "testing_settings":
        redirectTo(testerAccountPaths.registrationTestingSettings);
        break;

      case "hardware_and_software":
        redirectTo(testerAccountPaths.registrationHardwareAndSoftware);
        break;

      case "community_test":
        redirectTo(testerAccountPaths.registrationCommunityTest);
        break;

      case "follow_up_test":
        redirectTo(testerAccountPaths.registrationFollowUpTest);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Loader loaded={showChildren}>{children}</Loader>
    </div>
  );
};

export default RedirectionsFilter;
